module.exports = __webpack_public_path__ + "img/01.9c27b4c3.svg";